import './text.css'
import React from 'react'
import img1 from '../img/bg-pattern-light.png'

function Text() {
  return (
    <div className='text'>
       <div className='color-overlay'></div>
       <div className="container">
            <div className="row">
                <div className='col-12'>
                <h2 className='callh2'>الموقع الإلكتروني هو بوابة شركتك نحو العالم الافتراضي إنه عنوانك الرقمي الذي يمكن للجميع زيارته بسهولة. تمامًا كما يكون المقر الفعلي</h2>
                </div>
            </div>
        </div>
        <div className='bottom-pattern '>
            <img src={img1} alt="back" />
        </div>
    </div>
  )
}

export default Text
